import { render, staticRenderFns } from "./PointCardProfile.vue?vue&type=template&id=6f31644b&scoped=true"
import script from "./PointCardProfile.vue?vue&type=script&lang=js"
export * from "./PointCardProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f31644b",
  null
  
)

export default component.exports